import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { RegistriService } from 'src/app/core/registri.service';
import { RegistriResponse } from 'src/app/shared/models/registriRequest.model';

@Component({
  selector: "app-registers-table",
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  @if (registri(); as registri) {
    @if (registri.protocollo.length > 0) {
      <div class="registro-protocollo">
        <h4>Protocollo</h4>
        <app-register-result-table
          [data]="registri.protocollo"
          [columns]="registriService.colsProtocollo"
          [registerType]="'Protocollo'"
        />
      </div>
    }

    @if (registri.carico.length > 0) {
      <div class="registro-carico">
        <h4>Carico</h4>
        <app-register-result-table
          [data]="registri.carico"
          [columns]="registriService.colsCarico"
          [registerType]="'Carico'"
        />
      </div>
    }

    @if (registri.controllo.length > 0) {
      <div class="registro-controllo">
        <h4>Controllo</h4>
        <app-register-result-table
          [data]="registri.controllo"
          [columns]="registriService.colsUnicoControllo"
          [registerType]="'Controllo'"
        />
      </div>
    }

    @if (registri.riproduzioni.length > 0) {
      <div class="registro-riproduzioni">
        <h4>Riproduzioni</h4>
        <app-register-result-table
          [data]="registri.riproduzioni"
          [columns]="registriService.colsRiproduzioni"
          [registerType]="'Controllo'"
        />
      </div>
    }

    @if (registri.distruzioni.length > 0) {
      <div class="registro-distruzioni">
        <h4>Distruzioni</h4>
        <app-register-result-table
          [data]="registri.distruzioni"
          [columns]="registriService.colsDistruzioni"
          [registerType]="'Distruzioni'"
        />
      </div>
    }

    @if (registri.cis.length > 0) {
      <div class="registro-allegatiCIS">
        <h4>Allegati CIS</h4>
        <app-register-result-table
          [data]="registri.cis"
          [columns]="registriService.colsAllegatiCIS"
          [registerType]="'CIS'"
        />
      </div>
    }
  }
  `,
  styles: [`
    .registro-protocollo,
    .registro-carico,
    .registro-controllo,
    .registro-riproduzioni,
    .registro-distruzioni,
    .registro-allegatiCIS {
      overflow-x: auto;
      margin-bottom: 1rem;
    }

    :host ::ng-deep .p-datatable {
      width: 100vw;
    }
  `],
})
export class RegistersTableComponent {
  registri = input.required<RegistriResponse | null>();

  registriService = inject(RegistriService);
}
